module.exports = __webpack_public_path__ + "img/barncancerfonden.ec5b05d1.png";